"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RespondMessageDefinition = exports.RequestMessageDefinition = exports.MessageDefinition = exports.Message = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MessageDefinition = exports.MessageDefinition = /*#__PURE__*/function () {
  function MessageDefinition(msgCategory, msgType) {
    _classCallCheck(this, MessageDefinition);
    this.msgCategory = msgCategory;
    this.msgType = msgType;
  }
  return _createClass(MessageDefinition, [{
    key: "matches",
    value: function matches(other) {
      return this.msgCategory === other.msgCategory && this.msgType === other.msgType;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.msgCategory + ", " + this.msgType;
    }
  }]);
}();
var RequestMessageDefinition = exports.RequestMessageDefinition = /*#__PURE__*/function (_MessageDefinition) {
  function RequestMessageDefinition() {
    _classCallCheck(this, RequestMessageDefinition);
    return _callSuper(this, RequestMessageDefinition, arguments);
  }
  _inherits(RequestMessageDefinition, _MessageDefinition);
  return _createClass(RequestMessageDefinition);
}(MessageDefinition);
var RespondMessageDefinition = exports.RespondMessageDefinition = /*#__PURE__*/function (_MessageDefinition2) {
  function RespondMessageDefinition() {
    _classCallCheck(this, RespondMessageDefinition);
    return _callSuper(this, RespondMessageDefinition, arguments);
  }
  _inherits(RespondMessageDefinition, _MessageDefinition2);
  return _createClass(RespondMessageDefinition);
}(MessageDefinition);
var Message = exports.Message = /*#__PURE__*/function () {
  function Message(messageDefinition, payload, last) {
    _classCallCheck(this, Message);
    this.msgCategory = messageDefinition.msgCategory;
    this.msgType = messageDefinition.msgType;
    this.payload = payload;
    this.last = last === undefined ? true : last;
  }
  return _createClass(Message, [{
    key: "getDefinition",
    value: function getDefinition() {
      return new MessageDefinition(this.msgCategory, this.msgType);
    }
  }, {
    key: "matches",
    value: function matches(other) {
      return this.getDefinition().matches(other);
    }
  }], [{
    key: "parseJson",
    value: function parseJson(jsonString) {
      try {
        var jsonObj = JSON.parse(jsonString);
        var msgDef = new MessageDefinition(jsonObj.msgCategory, jsonObj.msgType);
        return new Message(msgDef, jsonObj.payload, jsonObj.last);
      } catch (e) {
        console.warn(e);
        return undefined;
      }
    }
  }]);
}();